import { AppComponent } from "./app/app.component";
import { createApplication } from "@angular/platform-browser";
import { appConfig } from "./app/app.config";
import { createCustomElement } from "@angular/elements";
import { ProjectDetailPopupComponent } from "./app/areas/eip/project-detail-popup/project-detail-popup.component";

// Mirror neptune NPT-1098: the prod canonical host is the apex (laketahoeinfo.org). The ingress
// serves www.laketahoeinfo.org with TLS, but the azure-application-gateway class can't issue the
// redirect, so canonicalize here — BEFORE Angular/Auth0 bootstrap. If we let the app start on www,
// it's a separate origin with its own Auth0 token cache (localStorage) and post-auth target
// (sessionStorage), splitting sessions from the apex. Gated on the exact prod www host; qa/dev
// (and the area subdomains) are unaffected.
if (window.location.hostname === "www.laketahoeinfo.org") {
    window.location.replace("https://laketahoeinfo.org" + window.location.pathname + window.location.search + window.location.hash);
} else {
    (async () => {
        const app = createApplication(appConfig);
        (await app).bootstrap(AppComponent);
        //  (await app).bootstrap(MsalRedirectComponent);

        const projectDetailPopupComponent = createCustomElement(ProjectDetailPopupComponent, {
            injector: (await app).injector,
        });
        customElements.define("project-detail-popup-custom-element", projectDetailPopupComponent);
    })();
}
